module.exports = __webpack_public_path__ + "img/banner-yufang.c20368c3.png";